<main class="alterar_senha">
  <section class="alterar_senha__section">
    <div class="alterar_senha__section__logo"></div>
    <form class="alterar_senha__section__form" [formGroup]="loginForm" *ngIf="!isSubmitting && !isSubmitted && !hasError">
      <h1 class="alterar_senha__section__form__title">Alterar senha</h1>

      <mat-form-field
        class="alterar_senha__section__form__input"
        appearance="outline">
        <mat-icon matPrefix class="alterar_senha__section__form__input__icon">
          lock
        </mat-icon>
        <mat-label>Senha</mat-label>
        <input type="{{ passwordVisible ? 'text' : 'password' }}" matInput formControlName="senha" required />
        <button type="button" mat-icon-button matSuffix (click)="passwordVisible = !passwordVisible">
          <mat-icon class="alterar_senha__section__form__input__icon">
            {{ passwordVisible ? 'visibility' : 'visibility_off' }}
          </mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field
      class="alterar_senha__section__form__input"
      appearance="outline">
      <mat-icon matPrefix class="alterar_senha__section__form__input__icon">
        lock
      </mat-icon>
      <mat-label>Confirmar senha</mat-label>
      <input type="{{ passwordVisible ? 'text' : 'password' }}" matInput formControlName="confirmarSenha" required />
      <button type="button" mat-icon-button matSuffix (click)="passwordVisible = !passwordVisible">
        <mat-icon class="alterar_senha__section__form__input__icon">
          {{ passwordVisible ? 'visibility' : 'visibility_off' }}
        </mat-icon>
      </button>
    </mat-form-field>

      <button
        class="alterar_senha__section__form__button"
        type="submit"
        mat-raised-button
        [disabled]="!loginForm.valid"
        (click)="submit()">
        Alterar senha
      </button>
    </form>

    <app-spinner-animation *ngIf="isSubmitting" />
    <app-confirm-animation *ngIf="isSubmitted" />

    <p class="alterar_senha__section__message" *ngIf="isSubmitted">
      Senha alterada com sucesso, faça login para continuar.
    </p>

    <app-error-animation *ngIf="hasError" />

    <p class="alterar_senha__section__error" *ngIf="hasError">
      Ocorreu um erro no processo de alteração de senha. Tente novamente mais tarde.
    </p>

    <a class="alterar_senha__section__link" routerLink=".." *ngIf="isSubmitted || hasError">
      Ir para o login
    </a>
  </section>
</main>
